import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetPrompts } from "src/app/store/prompt/prompt.action";

export function PromptsResolver() {
    return inject(Store).dispatch(new GetPrompts({ sortBy: "id", sortDirection: "asc" }));
}